module.exports = __webpack_public_path__ + "img/GT.356905ce.svg";